const ErrorComponent = ({error}) => {
    return <div className="text-center text-red-700">
        Error: {error || 'An error occurred'}
    </div>
}

export default ErrorComponent;